import React from 'react'
import cn from 'classnames'
import { observer } from 'mobx-react'

import styles from './draggable.scss'

export interface IProps {
  className?: string
  children: React.ReactChild
  onDragStart: (e: React.DragEvent<HTMLDivElement>) => void
  onDragEnd: (e: React.DragEvent<HTMLDivElement>) => void
}

class Draggable extends React.PureComponent<IProps> {
  handleDragStart = (e: React.DragEvent<HTMLDivElement>) => {
    e.dataTransfer.effectAllowed = 'move'
    e.dataTransfer.setData('text/html', (e.target as any).parentNode) // Grabs the whole input not just the ... component
    e.dataTransfer.setDragImage((e.target as any).parentNode, 20, 20) // Getting parentNode does not exist without any type
    this.props.onDragStart(e)
  }

  handleDragEnd = (e: React.DragEvent<HTMLDivElement>) => {
    this.props.onDragEnd(e)
  }

  render() {
    const { className, children, ...others } = this.props
    return (
      <div
        draggable
        className={cn(styles.container, className)}
        {...others}
        onDragStart={(e: React.DragEvent<HTMLDivElement>) =>
          this.handleDragStart(e)
        }
        onDragEnd={(e: React.DragEvent<HTMLDivElement>) =>
          this.handleDragEnd(e)
        }
      >
        {children}
      </div>
    )
  }
}

export default observer(Draggable)
